import { Component, OnInit, HostListener, Renderer2, ElementRef } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { BlockUIService } from '../service/block-ui-service/blockui.service';
import { Constant } from '../shared/constant';
import { CommonService } from '../service/common-service/common.service';
import { LaunchParams } from '../shared/Models/LaunchParams';
import { DomSanitizer } from '@angular/platform-browser';
import { SaveStatusParam } from '../shared/Models/SaveStautusParams';
import { ActivatedRoute } from '@angular/router';
import { trigger, transition, animate, style, state } from '@angular/animations';

@Component({
  selector: 'app-lti',
  templateUrl: './lti.component.html',
  styleUrls: ['./lti.component.css'],
  animations: [
    trigger('slideInOut', [
      state('open', style({ transform: 'translate(+100%)' })),
      state('closed', style({ transform: 'translate(0%)' })),
      transition('open => closed', [
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition('closed => open', [
        animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))
      ]),
    ]),
  ]
})
export class LTIComponent implements OnInit {
  Iframeheight!: number;
  LaunchParams: LaunchParams;
  EHRLearningUnitInfo: any;
  LULearningActivityTypeID!: number | null;
  LAResourceTypeID!: number | null;

  LTIIFrameSource: string = '';

  LTIChildFrame: string = '';

  IsLTIChildFrameVisible = false;

  IsEHRLaunched = false;
  IsDialogVisible = false;
  width = 475;
  isMobile = false;
  Old_XCoordinate = 0;
  Grabber = false;

  constructor(private domSanitzer: DomSanitizer, private cookieService: CookieService, private commonService: CommonService,
              private route: ActivatedRoute, private blockUIService: BlockUIService, private renderer: Renderer2,
              private elementRef: ElementRef) {
    this.LaunchParams = new LaunchParams();
  }

  ngOnInit(): void {
    this.blockUIService.BlockUIAngular();
    window.self.parent.postMessage('shellBlockUI', Constant.OriginUrlPattern);
    this.LaunchParams.ContentProductName = this.cookieService.get(Constant.SelectedTutorialName);
    this.LaunchParams.ContentProductModuleName = this.cookieService.get(Constant.SelectedModuleName);
    this.LULearningActivityTypeID = isNaN(parseInt(this.cookieService.get('')!, 10)) ? null : parseInt(this.cookieService.get('')!, 10);
    this.LAResourceTypeID = isNaN(parseInt(this.cookieService.get('')!, 10)) ? null : parseInt(this.cookieService.get('')!, 10);
    this.isMobile = this.checkMobile();

    let LaunchParamsJSON;
    if (this.route.snapshot.queryParams.data) {
      LaunchParamsJSON = JSON.parse(this.route.snapshot.queryParams.data);
    }
    if (LaunchParamsJSON) {
      this.LaunchParams.ApplicationId = LaunchParamsJSON.ApplicationId;
      this.LaunchParams.LearningActivityId = LaunchParamsJSON.LearningActivityId;
      this.LaunchParams.LearningUnitId = LaunchParamsJSON.LearningUnitId;
      this.LaunchParams.InstitutionId = LaunchParamsJSON.InstitutionId;
      this.LaunchParams.InstitutionName = LaunchParamsJSON.InstitutionName;
      this.LaunchParams.CohortId = LaunchParamsJSON.CohortId;
      this.LaunchParams.CohortName = LaunchParamsJSON.CohortName;
      this.LaunchParams.ConsortiumName = LaunchParamsJSON.ConsortiumName;
      this.LaunchParams.DocumentTarget = LaunchParamsJSON.DocumentTarget;
      this.LaunchParams.ExternalSourceName = LaunchParamsJSON.ExternalSourceName;
      this.LaunchParams.InstitutionPurchaseId = LaunchParamsJSON.InstitutionPurchaseId;
      this.LaunchParams.LearningActivityTypeId = LaunchParamsJSON.LearningActivityTypeId;
      this.LaunchParams.LearningUnitResourceId = LaunchParamsJSON.LearningUnitResourceId;
      this.LaunchParams.Role = LaunchParamsJSON.Role;
      this.LaunchParams.ConsortiumId = LaunchParamsJSON.ConsortiumId;
      this.LaunchParams.AuthorizationId = LaunchParamsJSON.AuthorizationId;
      this.LaunchParams.customParameters = LaunchParamsJSON.customParameters;
      this.LaunchParams.BookMarkLocation = LaunchParamsJSON.BookMarkLocation;
      this.LaunchParams.EndTime = LaunchParamsJSON.EndTime;
      this.LaunchParams.FrameScrolling = LaunchParamsJSON.FrameScrolling;
      this.LaunchParams.IFrameStyle = LaunchParamsJSON.IFrameStyle;
      this.LaunchParams.LearningSessionDetailId = LaunchParamsJSON.LearningSessionDetailId;
      this.LaunchParams.LearningUnitAttemptID = LaunchParamsJSON.LearningUnitAttemptID;
      this.LaunchParams.RemediationLink = LaunchParamsJSON.RemediationLink;
      this.LaunchParams.ResourceID = LaunchParamsJSON.ResourceID;
      this.LaunchParams.ResourceLocation = LaunchParamsJSON.ResourceLocation;
      this.LaunchParams.ShouldShowheader = LaunchParamsJSON.ShouldShowheader;
      this.LaunchParams.StartTime = LaunchParamsJSON.StartTime;
      this.LaunchParams.UserID = LaunchParamsJSON.UserID;
      this.LaunchParams.IsLTIModule = LaunchParamsJSON.IsLTIModule;
      this.LaunchParams.IsRemedaition = LaunchParamsJSON.IsRemedaition;
      this.LaunchParams.UrlEncodeCustomParameters = LaunchParamsJSON.UrlEncodeCustomParameters;
      this.LaunchParams.customParameters = JSON.parse(decodeURIComponent(this.LaunchParams.UrlEncodeCustomParameters).replace(/'/g, '"'));
      const attemptIDParam = { name: 'static_content_attempt_id', value: this.LaunchParams.LearningUnitAttemptID.toString() };
      this.LaunchParams.customParameters.push(attemptIDParam);
      if (this.LaunchParams.LearningActivityTypeId === Constant.LearningActivityTypeKognito ||
         this.LaunchParams.LearningActivityTypeId === Constant.LearningActivityTypeEHRTutor ||
         this.LaunchParams.LearningActivityTypeId === Constant.LearningActivityTypeEHRTReadOnlyChart ||
         this.LaunchParams.LearningActivityTypeId === Constant.LearningActivityTypeHealthAssess ||
         this.LaunchParams.LearningActivityTypeId === Constant.LearningActivityTypeSkills) {
        this.Iframeheight = window.innerHeight;
      }
    }
    this.LaunchParams.IsLTITimeOutEnable = "false";
    this.commonService.LTILaunch(this.LaunchParams).subscribe((data: any) => {
      this.LTIIFrameSource = data;
      this.blockUIService.UnBlockUIAngular()
      window.self.parent.postMessage('shellUnblockUI', Constant.OriginUrlPattern);
    });
  }
  checkMobile(): boolean {
    // return (this.deviceService.isMobile() || this.deviceService.isTablet());
    return (window.navigator.maxTouchPoints > 0 || /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent));
  }

  @HostListener('window:message', ['$event'])
  async receiveMessage(event: any) {
    var message;
    var data;
    if (typeof event.data === 'string') {
      const parameters = event.data.split('|');
      message = parameters[0];
      data = parameters[1];
    }

    switch (message) {
      case 'CloseAttempt':
        this.SaveSatus();
        window.self.parent.postMessage('NavigateToProducts|', Constant.OriginUrlPattern);
        break;
      case 'ShellBlockUI':
        this.blockUIService.BlockUIAngular();
        break;
      case 'ShellUnblockUI':
        this.blockUIService.UnBlockUIAngular();
        break;
      case 'DoNotWaitForClosed':
        this.blockUIService.UnBlockUIAngular();
        break;
      case 'NavigateToProducts':
        window.self.parent.postMessage('NavigateToProducts|', Constant.OriginUrlPattern);
        break;
      case 'InactivityTimerExpired': {
        window.removeEventListener('beforeunload', this.windowunload, false);
        window.self.parent.postMessage('NavigateToProducts|', Constant.OriginUrlPattern);
        break;
      }
      case 'LTITimeSpentError':
        window.removeEventListener('beforeunload', this.windowunload, false);
        this.cookieService.put(Constant.ErrorMessageCookieName,
          'Error Keeping Track Of Time Spent. Please re-launch the Tutorial again',
          { path: '/' });
          window.self.parent.postMessage('NavigateToProducts|', Constant.OriginUrlPattern);
        break;
      case 'ShowHideChart':
        this.LoadChildFrame();
        break;
      case 'unityfailure':
      case 'unitycompletion':
        window.self.parent.postMessage(event.data, Constant.OriginUrlPattern);
        break;
      case 'SyncLTITutorialAttempt':
        window.self.parent.postMessage('SyncLTITutorialAttempt|' + data, Constant.OriginUrlPattern);
        break;
    }
  }

  SaveSatus(): void {
    let saveStatusParams = new SaveStatusParam();
    saveStatusParams = {
      AuthorizationID: this.LaunchParams.AuthorizationId,
      LearningSessionDetailID: this.LaunchParams.LearningSessionDetailId,
      BookMarkId : ''
    };
    setTimeout(() => {
      this.commonService.SaveStatus(saveStatusParams);
    }, 30000);
  }

  LaunchEHR(isReadOnly: boolean): void {
    const ehrLaunchParams: LaunchParams = this.LaunchParams;
    ehrLaunchParams.LearningUnitId = this.EHRLearningUnitInfo.learningUnitID;
    ehrLaunchParams.LearningActivityTypeId = this.EHRLearningUnitInfo.learningActivityTypeID;
    ehrLaunchParams.LearningUnitResourceId = this.EHRLearningUnitInfo.learningUnitResourceID;
    this.commonService.LTILaunch(ehrLaunchParams).subscribe((data: any) => {
      this.LTIChildFrame = data;
      this.IsLTIChildFrameVisible = true;
      window.addEventListener('beforeunload', this.windowunload, false);
    });
  }

  LoadChildFrame(): void {
    this.ToggleChart();
    if (!this.IsEHRLaunched) {
      // this.toggleIFrame()
      this.commonService.GetEHRLearningUnitDetails(this.LaunchParams.LearningUnitId, '0').subscribe((data: any) => {
        this.EHRLearningUnitInfo = data;
        this.IsEHRLaunched = true;
        this.LaunchEHR(false);
      });
    }

  }
  windowunload() {
    if (this.LaunchParams.LearningActivityTypeId !== 34 && this.LaunchParams.LearningActivityTypeId !== 37) {
      if (this.IsDialogVisible) {
        // close dialogue UI Implementtaion
        // $('#CloseDialog').dialog('open');
      }
    }
    return '';
  }

  ToggleChart(): void {
    this.IsLTIChildFrameVisible = !this.IsLTIChildFrameVisible;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.Grabber) {
      return;
    }
    this.resizer(this.Old_XCoordinate - event.clientX);
    this.Old_XCoordinate = event.clientX;
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.Grabber = false;
    this.SetPointer('auto');
  }
  resizer(offsetY: number) {
    this.width += offsetY;
  }

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.SetPointer('none');
    this.Grabber = true;
    this.Old_XCoordinate = event.clientX;
  }
  SetPointer(value: string): void {
    const iframe = this.elementRef.nativeElement.querySelector('iframe');
    this.renderer.setStyle(iframe, 'pointer-events', value);
    const ehriframecontainer = this.elementRef.nativeElement.querySelector('#LTIChildFrame');
    this.renderer.setStyle(ehriframecontainer, 'pointer-events', value);
  }

}
